import React from 'react';
import { Typography } from '@mui/material';
import { sectionTitleStyles } from './SectionTitle.styles';

const SectionTitle = ({ children }) => {
  return (
    <Typography sx={sectionTitleStyles.title}>
      {children}
    </Typography>
  );
};

export default SectionTitle;

